import { useState, useEffect } from "react"
import Modal from 'react-bootstrap/Modal';
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList";
import { enumUtil } from "../../../../utils/Enum"
import isNull from "../../../../utils/NullChecking"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import { useSelector } from "react-redux";
import Loader from "../../../shared/Loader/Loader"
import SearchList from "../../../Scheduler/Settings/SearchList";
import ModalFooter from "../../Shared/ModalFooter";
import FormValidator from "../../../../utils/FormValidator";
import DropdownValueHandler from '../../../shared/SuperSearch/DropdownValueHandler';
import { FindSecondChild } from "../../../../utils/FindMenuOption";


const LocationProvider = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Location')?.IsAdd
    const TotalTime = [
        { value: '', display: '' },
        { value: '12:00 AM', display: '12:00 AM' },
        { value: '12:30 AM', display: '12:30 AM' },
        { value: '01:00 AM', display: '01:00 AM' },
        { value: '01:30 AM', display: '01:30 AM' },
        { value: '02:00 AM', display: '02:00 AM' },
        { value: '02:30 AM', display: '02:30 AM' },
        { value: '03:00 AM', display: '03:00 AM' },
        { value: '03:30 AM', display: '03:30 AM' },
        { value: '04:00 AM', display: '04:00 AM' },
        { value: '04:30 AM', display: '04:30 AM' },
        { value: '05:00 AM', display: '05:00 AM' },
        { value: '05:30 AM', display: '05:30 AM' },
        { value: '06:00 AM', display: '06:00 AM' },
        { value: '06:30 AM', display: '06:30 AM' },
        { value: '07:00 AM', display: '07:00 AM' },
        { value: '07:30 AM', display: '07:30 AM' },
        { value: '08:00 AM', display: '08:00 AM' },
        { value: '08:30 AM', display: '08:30 AM' },
        { value: '09:00 AM', display: '09:00 AM' },
        { value: '09:30 AM', display: '09:30 AM' },
        { value: '10:00 AM', display: '10:00 AM' },
        { value: '10:30 AM', display: '10:30 AM' },
        { value: '11:00 AM', display: '11:00 AM' },
        { value: '11:30 AM', display: '11:30 AM' },
        { value: '12:00 PM', display: '12:00 PM' },
        { value: '12:30 PM', display: '12:30 PM' },
        { value: '01:00 PM', display: '01:00 PM' },
        { value: '01:30 PM', display: '01:30 PM' },
        { value: '02:00 PM', display: '02:00 PM' },
        { value: '02:30 PM', display: '02:30 PM' },
        { value: '03:00 PM', display: '03:00 PM' },
        { value: '03:30 PM', display: '03:30 PM' },
        { value: '04:00 PM', display: '04:00 PM' },
        { value: '04:30 PM', display: '04:30 PM' },
        { value: '05:00 PM', display: '05:00 PM' },
        { value: '05:30 PM', display: '05:30 PM' },
        { value: '06:00 PM', display: '06:00 PM' },
        { value: '06:30 PM', display: '06:30 PM' },
        { value: '07:00 PM', display: '07:00 PM' },
        { value: '07:30 PM', display: '07:30 PM' },
        { value: '08:00 PM', display: '08:00 PM' },
        { value: '08:30 PM', display: '08:30 PM' },
        { value: '09:00 PM', display: '09:00 PM' },
        { value: '09:30 PM', display: '09:30 PM' },
        { value: '10:00 PM', display: '10:00 PM' },
        { value: '10:30 PM', display: '10:30 PM' },
        { value: '11:00 PM', display: '11:00 PM' },
        { value: '11:30 PM', display: '11:30 PM' },

    ]
    const { isopenLocationSch, isClosed, LocationID, LocationName, is } = { ...props }
    const [MondayID, setMondayID] = useState("0")
    const [tuesdayID, settuesdayID] = useState("0")
    const [providerlocation, setProviderlocation] = useState(false)
    const [WendesdayID, setWendesdayID] = useState("0")
    const [ThursdayID, setThursdayID] = useState("0")
    const [FridayID, setFridayID] = useState("0")
    const [SaturdayID, setSaturdayID] = useState("0")
    const [SundayID, setSundayID] = useState("0")
    const [List, setList] = useState([])
    const [ids, setIds] = useState([])
    const [mainAlllocation, setmainAlllocation] = useState([])
    const [InActive, setInActive] = useState([])
    const [ItemScc, setItemScc] = useState([])
    const [noData, setNoData] = useState(false);


    function convert12HourTo24Hour(time12h) {
        const [time, period] = time12h !== undefined ? time12h.split(' ') : "";
        const [hours, minutes] = time !== undefined ? time.split(':') : "";

        let hours24 = parseInt(hours, 10);
        if (period === 'PM' && hours24 !== 12) {
            hours24 += 12;
        } else if (period === 'AM' && hours24 === 12) {
            hours24 = 0;
        }

        return `${hours24.toString().padStart(2, '0')}:${minutes}`;
    }

    const parseTime = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    };


    function convertToTimeObject(time1, time2) {
        // console.log(time1,'time 1' ,time2,'time2');
        let FirstTime24 = convert12HourTo24Hour(time1)
        let SecondTime24 = convert12HourTo24Hour(time2)

        const parseTime = (time) => {
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        };
        const parsedTime1 = parseTime(FirstTime24);
        const parsedTime2 = parseTime(SecondTime24);

        // console.log(parsedTime1, parsedTime2, "check")
        if (parsedTime1 < parsedTime2) {
            return -1;
        } else if (parsedTime1 > parsedTime2) {
            return 1;
        } else {
            return 0; // Times are equal
        }
    }


    // function convertToTimeobjectforbreak(startTime, endTime, time1, time2) {
    //     console.log(startTime,'sdsad');

    //     //.log(time1,'time 1' ,time2,'time2');
    //     let FirstTime24 = convert12HourTo24Hour(time1)
    //     let SecondTime24 = convert12HourTo24Hour(time2)
    //     let StartTime = convert12HourTo24Hour(startTime)
    //     let EndTime = convert12HourTo24Hour(endTime)

    //     const parseTime = (time) => {
    //         const [hours, minutes] = time.split(':').map(Number);
    //         return hours * 60 + minutes;
    //     };
    //     const parsedTime1 = parseTime(FirstTime24);
    //     const parsedTime2 = parseTime(SecondTime24);
    //     const parsedStartTime = parseTime(StartTime)
    //     const parsedEndTime = parseTime(EndTime)


    //     // console.log(parsedTime2, parsedStartTime, "condition")

    //     // console.log(parsedStartTime, parsedEndTime, "check")
    //     if (parsedTime1 < parsedTime2) {
    //         return -1;
    //     } else if (parsedTime1 > parsedTime2) {
    //         if (parsedTime2 > parsedStartTime){
    //             return 1 
    //         }
    //         else {
    //             return -1
    //         }

    //     } else {
    //         return 0; // Times are equal
    //     }
    // }


    let valModal = {}
    // validation modal 
    let ValidationModal = {
        MondayStartTime: "",
        MondayEndTime: "",
        TuesdayStartTime: "",
    }

    const [POSValidationModal, setPOSValidationModal] = useState(ValidationModal)

    let Monday_Model = {
        ID: "0",
        Day: "Monday",
        StartTime: "",
        EndTime: "",
        OverBookAllowed: false,
        BreakStartTime: "",
        BreakEndTime: "",


    }

    let Tuesday_Model = {
        ID: "0",
        Day: "Tuesday",
        StartTime: "",
        EndTime: "",
        OverBookAllowed: false,
        BreakStartTime: "",
        BreakEndTime: "",
    }

    let Wednesday_Model = {
        ID: "0",
        Day: "Wendesday",
        StartTime: "",
        EndTime: "",
        OverBookAllowed: false,
        BreakStartTime: "",
        BreakEndTime: "",
    }
    let Thursday_Model = {
        ID: "0",
        Day: "Thursday",
        StartTime: "",
        EndTime: "",
        OverBookAllowed: false,
        BreakStartTime: "",
        BreakEndTime: "",
    }
    let Friday_Model = {
        ID: "0",
        Day: "Friday",
        StartTime: "",
        EndTime: "",
        OverBookAllowed: false,
        BreakStartTime: "",
        BreakEndTime: "",
    }
    let Saturday_Model = {
        ID: "0",
        Day: "Saturday",
        StartTime: "",
        EndTime: "",
        OverBookAllowed: false,
        BreakStartTime: "",
        BreakEndTime: "",
    }
    let Sunday_Model = {
        ID: "0",
        Day: "Sunday",
        StartTime: "",
        EndTime: "",
        OverBookAllowed: false,
        BreakStartTime: "",
        BreakEndTime: "",
    }



    const API_URL = enumUtil.controller.General
    const [mainMondayModal, setmainMondayModal] = useState(Monday_Model);
    const [MondaySaveUpdateModal, setMondaySaveUpdateModal] = useState({})

    const [mainTuesdayModel, setmainTuesdayModel] = useState(Tuesday_Model);
    const [TuesdaySaveUpdateModal, setTuesdaySaveUpdateModal] = useState({})

    const [mainWednesdayModel, setmainWednesdayModel] = useState(Wednesday_Model);
    const [WednesdaySaveUpdateModal, setWednesdaySaveUpdateModal] = useState({})

    const [mainThursdayModel, setmainThursdayModel] = useState(Thursday_Model);
    const [ThursdaySaveUpdateModal, setThursdaySaveUpdateModal] = useState({})

    const [mainFridayModel, setmainFridayModel] = useState(Friday_Model);
    const [FridaySaveUpdateModal, setFridaySaveUpdateModal] = useState({})


    const [mainSaturdayModel, setmainSaturdayModel] = useState(Saturday_Model);
    const [SaturdaySaveUpdateModal, setSaturdaySaveUpdateModal] = useState({})


    const [mainSundayModel, setmainSundayModel] = useState(Sunday_Model);
    const [SundaySaveUpdateModal, setSundaySaveUpdateModal] = useState({})


    const [isLoading, setIsLoading] = useState(false)




    const handleVisitTypeChange = (e) => {

        let { name, value } = e.target;
        let modal = { ...mainMondayModal };
        let saveModal = { ...MondaySaveUpdateModal }
        if (name === 'OverBookAllowed') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }

        setmainMondayModal(modal)
        for (var property in Monday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }

            }
        }

        setMondaySaveUpdateModal(saveModal)

    }

    const handleTuesdayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainTuesdayModel };
        let saveModal = { ...TuesdaySaveUpdateModal }
        if (name === 'OverBookAllowed') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setmainTuesdayModel(modal)
        for (var property in Tuesday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }


            }
        }

        setTuesdaySaveUpdateModal(saveModal)

    }
    const handleWednesdayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainWednesdayModel };
        let saveModal = { ...WednesdaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }



        setmainWednesdayModel(modal)
        for (var property in Wednesday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }

            }
        }

        setWednesdaySaveUpdateModal(saveModal)

    }
    const handleThursdayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainThursdayModel };
        let saveModal = { ...ThursdaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }



        setmainThursdayModel(modal)
        for (var property in Thursday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }


            }
        }

        setThursdaySaveUpdateModal(saveModal)

    }
    const handleFridayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainFridayModel };
        let saveModal = { ...FridaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }



        setmainFridayModel(modal)
        for (var property in Friday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }

            }
        }

        setFridaySaveUpdateModal(saveModal)

    }
    const handleSaturdayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainSaturdayModel };
        let saveModal = { ...SaturdaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }



        setmainSaturdayModel(modal)
        for (var property in Saturday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }


            }
        }

        setSaturdaySaveUpdateModal(saveModal)

    }
    const handleSundayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainSundayModel };
        let saveModal = { ...SundaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }



        setmainSundayModel(modal)
        for (var property in Sunday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }


            }
        }

        setSundaySaveUpdateModal(saveModal)

    }

    const [inputColumn, setInputCoulmn] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        setmainMondayModal(Monday_Model)
        setmainTuesdayModel(Tuesday_Model)
        setmainWednesdayModel(Wednesday_Model)
        setmainThursdayModel(Thursday_Model)
        setmainFridayModel(Friday_Model)
        setmainSaturdayModel(Saturday_Model)
        setmainSundayModel(Sunday_Model)
        ServerRequestProtected(API_URL + "/GetLocationSchedule", 'post', {
            "TableName": enumUtil.enumAPITableName.LOCATIONSCHEDULE,
            "ID": LocationID + "",
        }).then((response) => {

            console.log(response, 'respo');
            setIsLoading(false)
            const mondayFiltered = response?.filter(item => item?.Day === "Monday");
            setmainMondayModal(mondayFiltered[0])
            console.log(mondayFiltered[0], 'monday data');
            setMondayID(mondayFiltered[0]?.LocationScheduleID)
            const thuesdayFiltered = response?.filter(item => item?.Day === "Tuesday");
            setmainTuesdayModel(thuesdayFiltered[0])
            settuesdayID(thuesdayFiltered[0]?.LocationScheduleID)
            const wednesdayFiltered = response?.filter(item => item?.Day === "Wednesday");
            setmainWednesdayModel(wednesdayFiltered[0])
            setWendesdayID(wednesdayFiltered[0]?.LocationScheduleID)
            const thursdayFiltered = response?.filter(item => item?.Day === "Thursday");
            setmainThursdayModel(thursdayFiltered[0])
            setThursdayID(thursdayFiltered[0]?.LocationScheduleID)
            const fridayFiltered = response?.filter(item => item?.Day === "Friday");
            setmainFridayModel(fridayFiltered[0])
            setFridayID(fridayFiltered[0]?.LocationScheduleID)
            const saturdayFiltered = response?.filter(item => item?.Day === "Saturday");
            setmainSaturdayModel(saturdayFiltered[0])
            setSaturdayID(saturdayFiltered[0]?.LocationScheduleID)
            const sundayFiltered = response?.filter(item => item?.Day === "Sunday");
            setmainSundayModel(sundayFiltered[0])
            setSundayID(sundayFiltered[0]?.LocationScheduleID)
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            setNoData(true)
            if (!isNull(MondayID && tuesdayID && WendesdayID && ThursdayID && FridayID && SaturdayID && SundayID)) {
                setInputCoulmn(true)
                setMondayID("0")
                settuesdayID("0")
                setWendesdayID("0")
                setThursdayID("0")
                setFridayID("0")
                setSaturdayID("0")
                setSundayID("0")
            }
            setIsLoading(false)
        })

    }, [])


    console.log(mainMondayModal, 'monday model data ');

    const POSValidation = async () => {
        let ValidationModal = {};
        let models = [mainMondayModal, mainTuesdayModel, mainWednesdayModel, mainThursdayModel, mainFridayModel, mainSaturdayModel, mainSundayModel]
        let days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', "Saturday", "Sunday"]

        for (const [index, model] of models.entries()) {
            if (model.StartTime || model.EndTime || model.BreakEndTime || model.BreakStartTime || model.OverBookAllowed) {
                ValidationModal[days[index] + "StartTime"] = FormValidator(
                    model.StartTime,
                    enumUtil.enumValidationType.Required,
                    'Start Time',
                )


                ValidationModal[days[index] + 'EndTime'] = FormValidator(
                    model.EndTime,
                    enumUtil.enumValidationType.Required,
                    'End Time',
                )
                // ValidationModal[days[index] + "BreakStartTime"] = FormValidator(
                //     model.BreakStartTime,
                //     enumUtil.enumValidationType.Required,
                //     'Break Start Time',
                // )
                // ValidationModal[days[index] + "BreakEndTime"] = FormValidator(
                //     model.BreakEndTime,
                //     enumUtil.enumValidationType.Required,
                //     'Break End Time',
                // )

                if (!(model.StartTime && model.EndTime)) break

            }
        }

        if (Object.keys(ValidationModal).length === 0) {
            ValidationModal["MondayStartTime"] = FormValidator(
                mainMondayModal.StartTime,
                enumUtil.enumValidationType.Required,
                'Start Time',
            )


            ValidationModal['MondayEndTime'] = FormValidator(
                mainMondayModal.EndTime,
                enumUtil.enumValidationType.Required,
                'End Time',
            )
        }

        await setPOSValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    // console.log(POSValidationModal, 'popo');
    const handleSaveVistType = async () => {
        await POSValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // let list 
            // if(MondaySaveUpdateModal.StartTime !== ""){
            //     list =[{Day:'Monday',ID: MondayID + "", ...MondaySaveUpdateModal }]
            // }
            // else if (MondaySaveUpdateModal.StartTime !== "" && TuesdaySaveUpdateModal.StartTime !== "" ){
            //     list =[{Day:'Monday',ID: MondayID + "", ...MondaySaveUpdateModal },{ Day: 'Tuesday', ID: tuesdayID + "", ...TuesdaySaveUpdateModal }]
            // }
            let list = [{ Day: 'Monday', ID: MondayID + "", ...MondaySaveUpdateModal }, { Day: 'Tuesday', ID: tuesdayID + "", ...TuesdaySaveUpdateModal }, { Day: 'Wednesday', ID: WendesdayID + "", ...WednesdaySaveUpdateModal }, { Day: 'Thursday', ID: ThursdayID + "", ...ThursdaySaveUpdateModal }, { Day: 'Friday', ID: FridayID + "", ...FridaySaveUpdateModal }, { Day: 'Saturday', ID: SaturdayID + "", ...SaturdaySaveUpdateModal }, { Day: 'Sunday', ID: SundayID + "", ...SundaySaveUpdateModal }]
            let saveModal = {
                TableName: enumUtil.enumAPITableName.SAVELOCATIONSCHEDULE,
                LocationID: LocationID + "",
                data: [...list],
            }

            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveLocationSchedule", 'post', saveModal)
                .then((response) => {
                    setIsLoading(false)
                    if (!isNull(response.id)) {
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    }

                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    function convertTo24Hour(time) {
        // console.log("24HrsFormate", time);
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes] = timePart.split(":").map(Number);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    }

    function compareTimes(time1, time2) {
        if (!isNull(time1)) {

            const time1Obj = convertTo24Hour(time1);
            const time2Obj = convertTo24Hour(time2);

            const date1 = new Date();
            const date2 = new Date();

            date1.setHours(time1Obj.hours, time1Obj.minutes);
            date2.setHours(time2Obj.hours, time2Obj.minutes);

            // Compare times
            if (date2.getTime() > date1.getTime()) {
                return time2;
            }

        }
        else {
            return time2
        }
    }
    const handleSelectedMonday = (selectedData, name, type) => {

        let modal = { ...mainMondayModal };
        let saveModal = { ...MondaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainMondayModal['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value;

        } else {

            modal[name] = ''
            saveModal[name] = ''

        }

        setmainMondayModal(modal);
        setMondaySaveUpdateModal(saveModal);

        return selectedData
    }
    const handleSelectedTuesday = (selectedData, name, type) => {

        let modal = { ...mainTuesdayModel };
        let saveModal = { ...TuesdaySaveUpdateModal }

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainTuesdayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value;

        }
        else {

            modal[name] = ''
            saveModal[name] = ''

        }

        setmainTuesdayModel(modal)
        setTuesdaySaveUpdateModal(saveModal)

        return selectedData
    }
    const handleSelectedWendesday = (selectedData, name, type) => {
        let modal = { ...mainWednesdayModel };
        let saveModal = { ...WednesdaySaveUpdateModal };
        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainWednesdayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value;

        }
        else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setmainWednesdayModel(modal)
        setWednesdaySaveUpdateModal(saveModal)

        return selectedData

    }
    const handleSelectedThursday = (selectedData, name, type) => {

        let modal = { ...mainThursdayModel };
        let saveModal = { ...ThursdaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainThursdayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value;

        }
        else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setmainThursdayModel(modal);
        setThursdaySaveUpdateModal(saveModal);

        return selectedData
    }
    const handleSelectedFriday = (selectedData, name, type) => {

        let modal = { ...mainFridayModel };
        let saveModal = { ...FridaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainFridayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display;
            saveModal[name] = selectedData.value + "";

        }
        else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setmainFridayModel(modal)
        setFridaySaveUpdateModal(saveModal)

        return selectedData
    }
    const handleSelectedSaturday = (selectedData, name, type) => {

        let modal = { ...mainSaturdayModel };
        let saveModal = { ...SaturdaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainSaturdayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + '';


        }
        else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setmainSaturdayModel(modal);
        setSaturdaySaveUpdateModal(saveModal);

        return selectedData
    }
    const handleSelectedSunday = (selectedData, name, type) => {

        let modal = { ...mainSundayModel };
        let saveModal = { ...SundaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainSundayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + "";

        }
        else {

            modal[name] = ''
            saveModal[name] = ''

        }

        setmainSundayModel(modal);
        setSundaySaveUpdateModal(saveModal);

        return selectedData
    }
    return (
        <>
            <Modal show={isopenLocationSch} onHide={isClosed} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 provider_schedular location_schedular">
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="heading text-center w-100">Location Scheduler</span>
                        <button onClick={isClosed}> <i class="icon-Icon-metro-cross"></i></button>
                    </div>

                    <div className="d-flex days_header justify-content-end mt-1 pe-4 ps-2">
                        <div className="col-md-3">
                            <p >Start Time</p>

                        </div>
                        <div className="col-md-3 ms-2">
                            <p >End Time </p>
                        </div>
                        <div className="col-md-3">
                            <p className="position-relative">Break Start</p>
                        </div>
                        <div className="col-md-2 ms-1">
                            <p >Break End </p>
                        </div>
                    </div>
                    <div className="timing pt-2 pb-2 ps-4">
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="row w-100">
                                <div className="heading day mon">
                                    <span>MON</span>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.MondayStartTime ? ' input pe-0 error' : 'input pe-0'}>
                                        <select
                                            className="form-control"
                                            id="StartTime"
                                            name="StartTime"
                                            value={mainMondayModal?.StartTime}
                                            onChange={handleVisitTypeChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainMondayModal?.EndTime !== "") {
                                                    if (convertToTimeObject(mainMondayModal?.EndTime, e.display) === 1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }

                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.MondayStartTime ? ' input pe-0 error' : 'input pe-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='StartTime'
                                            name='StartTime'
                                            searchValue={mainMondayModal?.StartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainMondayModal?.EndTime !== "") {
                                                        return convertToTimeObject(mainMondayModal?.EndTime, e.display) === 1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedMonday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />


                                    </div>
                                </div>
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.MondayEndTime ? 'input error ' : 'input '}>
                                        <SuperSearchList
                                            type="client"
                                            id='EndTime'
                                            name='EndTime'
                                            searchValue={mainMondayModal?.EndTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainMondayModal?.StartTime !== "") {
                                                        return convertToTimeObject(mainMondayModal?.StartTime, e.display) === -1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedMonday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />



                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.MondayEndTime ? 'input error ' : 'input '}>
                                        <select
                                            className="form-control"
                                            id="EndTime"
                                            name="EndTime"
                                            onChange={handleVisitTypeChange}
                                            value={mainMondayModal?.EndTime}

                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainMondayModal?.StartTime !== "") {
                                                    if (convertToTimeObject(mainMondayModal?.StartTime, e.display) === -1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}

                                <div className="col-md-3 pe-0">
                                    <div className={"input p-0 flex-row"}>
                                        {/* <select className="form-control"
                                            id='BreakStartTime'
                                            name='BreakStartTime'
                                            value={mainMondayModal?.BreakStartTime}
                                            onChange={handleVisitTypeChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainMondayModal.StartTime)) < parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainMondayModal.EndTime)) > parseTime(convert12HourTo24Hour(e.display))) || index === 0) {
                                                    if (mainMondayModal?.BreakEndTime !== "") {
                                                        if (convertToTimeObject(mainMondayModal?.BreakEndTime, e.display) === 1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }

                                            })}
                                        </select> */}

                                        <SuperSearchList
                                            type="client"
                                            id="BreakStartTime"
                                            name="BreakStartTime"
                                            searchValue={mainMondayModal?.BreakStartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                    const start = parseTime(convert12HourTo24Hour(mainMondayModal.StartTime || "00:00 AM"));
                                                    const end = parseTime(convert12HourTo24Hour(mainMondayModal.EndTime || "11:59 PM"));

                                                    const isInRange = selectedTime > start && selectedTime < end;

                                                    if (!isInRange && index !== 0) return false;

                                                    if (mainMondayModal?.BreakEndTime) {
                                                        return convertToTimeObject(mainMondayModal?.BreakEndTime, e.display) === 1 || index === 0;
                                                    }

                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedMonday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />




                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center mx-1 form-check-input p-0'
                                                id="OverBookAllowed"
                                                name="OverBookAllowed"
                                                checked={mainMondayModal?.OverBookAllowed}
                                                value={mainMondayModal?.OverBookAllowed}
                                                onChange={(e) => handleVisitTypeChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="col-md-3 pe-0">
                                    <div className={"input ps-0"}>
                                        <select className="form-control"
                                            id='BreakEndTime'
                                            name='BreakEndTime'
                                            value={mainMondayModal?.BreakEndTime}
                                            onChange={handleVisitTypeChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainMondayModal.EndTime)) > parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainMondayModal.StartTime)) < parseTime(convert12HourTo24Hour(e.display))) || index === 0) {
                                                    if (mainMondayModal?.BreakStartTime !== "") {
                                                        if (convertToTimeObject(mainMondayModal?.BreakStartTime, e.display) === -1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <SuperSearchList
                                        type="client"
                                        id="BreakEndTime"
                                        name="BreakEndTime"
                                        searchValue={mainMondayModal?.BreakEndTime || ''}
                                        data={
                                            TotalTime?.filter((e, index) => {
                                                const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                const start = parseTime(convert12HourTo24Hour(mainMondayModal.StartTime || "00:00 AM"));
                                                const end = parseTime(convert12HourTo24Hour(mainMondayModal.EndTime || "11:59 PM"));

                                                const isInRange = selectedTime > start && selectedTime < end;

                                                if (!isInRange && index !== 0) return false;

                                                if (mainMondayModal?.BreakStartTime) {
                                                    return convertToTimeObject(mainMondayModal?.BreakStartTime, e.display) === -1 || index === 0;
                                                }

                                                return true;
                                            })
                                        }
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />





                                </div>


                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="row w-100">
                                <div className="heading day tue">
                                    <span>TUE</span>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.TuesdayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <select
                                            className="form-control"
                                            id="StartTime"
                                            name="StartTime"
                                            value={mainTuesdayModel?.StartTime}
                                            onChange={handleTuesdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainTuesdayModel?.EndTime !== "") {
                                                    if (convertToTimeObject(mainTuesdayModel?.EndTime, e.display) === 1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }

                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.TuesdayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='StartTime'
                                            name='StartTime'
                                            searchValue={mainTuesdayModel?.StartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainTuesdayModel?.EndTime !== "") {
                                                        return convertToTimeObject(mainTuesdayModel?.EndTime, e.display) === 1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedTuesday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.TuesdayEndTime ? 'input  error' : 'input '}>
                                        <select
                                            className="form-control"
                                            id="EndTime"
                                            name="EndTime"
                                            value={mainTuesdayModel?.EndTime}
                                            onChange={handleTuesdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainTuesdayModel?.StartTime !== "") {
                                                    if (convertToTimeObject(mainTuesdayModel?.StartTime, e.display) === -1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.TuesdayEndTime ? 'input error ' : 'input '}>
                                        <SuperSearchList
                                            type="client"
                                            id='EndTime'
                                            name='EndTime'
                                            searchValue={mainTuesdayModel?.EndTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainTuesdayModel?.StartTime !== "") {
                                                        return convertToTimeObject(mainTuesdayModel?.StartTime, e.display) === -1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedTuesday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />



                                    </div>
                                </div>
                                <div className="col-md-3 pe-0">
                                    <div className={"input p-0 flex-row"}>

                                        {/* <select className="form-control"
                                            id='BreakStartTime'
                                            name='BreakStartTime'
                                            value={mainTuesdayModel?.BreakStartTime}
                                            onChange={handleTuesdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainTuesdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainTuesdayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display))) || index === 0) {
                                                    if (mainTuesdayModel?.BreakEndTime !== "") {
                                                        if (convertToTimeObject(mainTuesdayModel?.BreakEndTime, e.display) === 1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }

                                            })}

                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id="BreakStartTime"
                                            name="BreakStartTime"
                                            searchValue={mainTuesdayModel?.BreakStartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                    const start = parseTime(convert12HourTo24Hour(mainTuesdayModel.StartTime || "00:00 AM"));
                                                    const end = parseTime(convert12HourTo24Hour(mainTuesdayModel.EndTime || "11:59 PM"));

                                                    const isInRange = selectedTime > start && selectedTime < end;

                                                    if (!isInRange && index !== 0) return false;

                                                    if (mainTuesdayModel?.BreakEndTime) {
                                                        return convertToTimeObject(mainTuesdayModel?.BreakEndTime, e.display) === 1 || index === 0;
                                                    }

                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedTuesday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />

                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center mx-1 form-check-input p-0'
                                                id="OverBookAllowed"
                                                name="OverBookAllowed"
                                                checked={mainTuesdayModel?.OverBookAllowed}
                                                value={mainTuesdayModel?.OverBookAllowed}
                                                onChange={(e) => handleTuesdayChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={"input ps-0"}>

                                        <select className="form-control"
                                            id='BreakEndTime'
                                            name='BreakEndTime'
                                            value={mainTuesdayModel?.BreakEndTime}
                                            onChange={handleTuesdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainTuesdayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainTuesdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display))) || index === 0) {
                                                    if (mainTuesdayModel?.BreakStartTime !== "") {
                                                        if (convertToTimeObject(mainTuesdayModel?.BreakStartTime, e.display) === -1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <SuperSearchList
                                        type="client"
                                        id="BreakEndTime"
                                        name="BreakEndTime"
                                        searchValue={mainTuesdayModel?.BreakEndTime || ''}
                                        data={
                                            TotalTime?.filter((e, index) => {
                                                const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                const start = parseTime(convert12HourTo24Hour(mainTuesdayModel.StartTime || "00:00 AM"));
                                                const end = parseTime(convert12HourTo24Hour(mainTuesdayModel.EndTime || "11:59 PM"));

                                                const isInRange = selectedTime > start && selectedTime < end;

                                                if (!isInRange && index !== 0) return false;

                                                if (mainTuesdayModel?.BreakStartTime) {
                                                    return convertToTimeObject(mainTuesdayModel?.BreakStartTime, e.display) === -1 || index === 0;
                                                }

                                                return true;
                                            })
                                        }
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedTuesday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="row w-100">
                                <div className="heading day wed">
                                    <span>WED</span>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.WednesdayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <select
                                            className="form-control"
                                            id="StartTime"
                                            name="StartTime"
                                            value={mainWednesdayModel?.StartTime}
                                            onChange={handleWednesdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainWednesdayModel?.EndTime !== "") {
                                                    if (convertToTimeObject(mainWednesdayModel?.EndTime, e.display) === 1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }

                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.WednesdayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='StartTime'
                                            name='StartTime'
                                            searchValue={mainWednesdayModel?.StartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainWednesdayModel?.EndTime !== "") {
                                                        return convertToTimeObject(mainWednesdayModel?.EndTime, e.display) === 1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedWendesday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.WednesdayEndTime ? 'input  error' : 'input '}>
                                        <select
                                            className="form-control"
                                            id="EndTime"
                                            name="EndTime"
                                            value={mainWednesdayModel?.EndTime}
                                            onChange={handleWednesdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainWednesdayModel?.StartTime !== "") {
                                                    if (convertToTimeObject(mainWednesdayModel?.StartTime, e.display) === -1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.WednesdayEndTime ? 'input error ' : 'input '}>
                                        <SuperSearchList
                                            type="client"
                                            id='EndTime'
                                            name='EndTime'
                                            searchValue={mainWednesdayModel?.EndTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainWednesdayModel?.StartTime !== "") {
                                                        return convertToTimeObject(mainWednesdayModel?.StartTime, e.display) === -1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedWendesday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />



                                    </div>
                                </div>
                                <div className="col-md-3 pe-0">
                                    <div className={"input p-0 flex-row"}>

                                        {/* <select className="form-control"
                                            id='BreakStartTime'
                                            name='BreakStartTime'
                                            value={mainWednesdayModel?.BreakStartTime}
                                            onChange={handleWednesdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                console.log(parseTime(convert12HourTo24Hour(mainWednesdayModel.StartTime)), parseTime(convert12HourTo24Hour(e.display)), parseTime(convert12HourTo24Hour(mainWednesdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display)), 'wedssssssssssssssssss');
                                                if ((parseTime(convert12HourTo24Hour(mainWednesdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainWednesdayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display))) || index === 0) {
                                                    if (mainWednesdayModel?.BreakEndTime !== "") {

                                                        if (convertToTimeObject(mainWednesdayModel?.BreakEndTime, e.display) === 1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }




                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id="BreakStartTime"
                                            name="BreakStartTime"
                                            searchValue={mainWednesdayModel?.BreakStartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                    const start = parseTime(convert12HourTo24Hour(mainWednesdayModel.StartTime || "00:00 AM"));
                                                    const end = parseTime(convert12HourTo24Hour(mainWednesdayModel.EndTime || "11:59 PM"));

                                                    const isInRange = selectedTime > start && selectedTime < end;

                                                    if (!isInRange && index !== 0) return false;

                                                    if (mainWednesdayModel?.BreakEndTime) {
                                                        return convertToTimeObject(mainWednesdayModel?.BreakEndTime, e.display) === 1 || index === 0;
                                                    }

                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedWendesday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center mx-1 form-check-input p-0'
                                                id="OverBookAllowed"
                                                name="OverBookAllowed"
                                                checked={mainWednesdayModel?.OverBookAllowed}
                                                value={mainWednesdayModel?.OverBookAllowed}
                                                onChange={(e) => handleWednesdayChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={"input ps-0"}>

                                        <select className="form-control"
                                            id='BreakEndTime'
                                            name='BreakEndTime'
                                            value={mainWednesdayModel?.BreakEndTime}
                                            onChange={handleWednesdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainWednesdayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainWednesdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display))) || index === 0) {
                                                    if (mainWednesdayModel?.BreakStartTime !== "") {
                                                        if (convertToTimeObject(mainWednesdayModel?.BreakStartTime, e.display) === -1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <SuperSearchList
                                        type="client"
                                        id="BreakEndTime"
                                        name="BreakEndTime"
                                        searchValue={mainWednesdayModel?.BreakEndTime || ''}
                                        data={
                                            TotalTime?.filter((e, index) => {
                                                const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                const start = parseTime(convert12HourTo24Hour(mainWednesdayModel.StartTime || "00:00 AM"));
                                                const end = parseTime(convert12HourTo24Hour(mainWednesdayModel.EndTime || "11:59 PM"));

                                                const isInRange = selectedTime > start && selectedTime < end;

                                                if (!isInRange && index !== 0) return false;

                                                if (mainWednesdayModel?.BreakStartTime) {
                                                    return convertToTimeObject(mainWednesdayModel?.BreakStartTime, e.display) === -1 || index === 0;
                                                }

                                                return true;
                                            })
                                        }
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedWendesday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>




                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="row w-100">
                                <div className="heading day thu">
                                    <span>THU</span>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.ThursdayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <select
                                            className="form-control"
                                            id="StartTime"
                                            name="StartTime"
                                            value={mainThursdayModel?.StartTime}
                                            onChange={handleThursdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainThursdayModel?.EndTime !== "") {
                                                    if (convertToTimeObject(mainThursdayModel?.EndTime, e.display) === 1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }

                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.ThursdayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='StartTime'
                                            name='StartTime'
                                            searchValue={mainThursdayModel?.StartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainThursdayModel?.EndTime !== "") {
                                                        return convertToTimeObject(mainThursdayModel?.EndTime, e.display) === 1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedThursday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.ThursdayEndTime ? 'input  error' : 'input '}>
                                        <select
                                            className="form-control"
                                            id="EndTime"
                                            name="EndTime"
                                            value={mainThursdayModel?.EndTime}
                                            onChange={handleThursdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainThursdayModel?.StartTime !== "") {
                                                    if (convertToTimeObject(mainThursdayModel?.StartTime, e.display) === -1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.ThursdayEndTime ? 'input error ' : 'input '}>
                                        <SuperSearchList
                                            type="client"
                                            id='EndTime'
                                            name='EndTime'
                                            searchValue={mainThursdayModel?.EndTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainThursdayModel?.StartTime !== "") {
                                                        return convertToTimeObject(mainThursdayModel?.StartTime, e.display) === -1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedThursday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />



                                    </div>
                                </div>
                                <div className="col-md-3 pe-0">
                                    <div className={"input p-0 flex-row"}>
                                        {/* <select className="form-control"
                                            id='BreakStartTime'
                                            name='BreakStartTime'
                                            value={mainThursdayModel?.BreakStartTime}
                                            onChange={handleThursdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainThursdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainThursdayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display))) || index === 0) {

                                                    if (mainThursdayModel?.BreakEndTime !== "") {
                                                        if (convertToTimeObject(mainThursdayModel?.BreakEndTime, e.display) === 1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }

                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id="BreakStartTime"
                                            name="BreakStartTime"
                                            searchValue={mainThursdayModel?.BreakStartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                    const start = parseTime(convert12HourTo24Hour(mainThursdayModel.StartTime || "00:00 AM"));
                                                    const end = parseTime(convert12HourTo24Hour(mainThursdayModel.EndTime || "11:59 PM"));

                                                    const isInRange = selectedTime > start && selectedTime < end;

                                                    if (!isInRange && index !== 0) return false;

                                                    if (mainThursdayModel?.BreakEndTime) {
                                                        return convertToTimeObject(mainThursdayModel?.BreakEndTime, e.display) === 1 || index === 0;
                                                    }

                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedThursday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center mx-1 form-check-input p-0'
                                                id="OverBookAllowed"
                                                name="OverBookAllowed"
                                                checked={mainThursdayModel?.OverBookAllowed}
                                                value={mainThursdayModel?.OverBookAllowed}
                                                onChange={(e) => handleThursdayChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={"input ps-0"}>

                                        <select className="form-control"
                                            id='BreakEndTime'
                                            name='BreakEndTime'
                                            value={mainThursdayModel?.BreakEndTime}
                                            onChange={handleThursdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainThursdayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainThursdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display))) || index === 0) {

                                                    if (mainThursdayModel?.BreakStartTime !== "") {
                                                        if (convertToTimeObject(mainThursdayModel?.BreakStartTime, e.display) === -1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }
                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <SuperSearchList
                                        type="client"
                                        id="BreakEndTime"
                                        name="BreakEndTime"
                                        searchValue={mainThursdayModel?.BreakEndTime || ''}
                                        data={
                                            TotalTime?.filter((e, index) => {
                                                const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                const start = parseTime(convert12HourTo24Hour(mainThursdayModel.StartTime || "00:00 AM"));
                                                const end = parseTime(convert12HourTo24Hour(mainThursdayModel.EndTime || "11:59 PM"));

                                                const isInRange = selectedTime > start && selectedTime < end;

                                                if (!isInRange && index !== 0) return false;

                                                if (mainThursdayModel?.BreakStartTime) {
                                                    return convertToTimeObject(mainThursdayModel?.BreakStartTime, e.display) === -1 || index === 0;
                                                }

                                                return true;
                                            })
                                        }
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedThursday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2 pe-0">
                            <div className="row w-100">
                                <div className="heading day fri">
                                    <span>FRI</span>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.FridayStartTime ? ' input pe-0 error' : ' input pe-0'}>
                                        <select
                                            className="form-control"
                                            id="StartTime"
                                            name="StartTime"
                                            value={mainFridayModel?.StartTime}
                                            onChange={handleFridayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainFridayModel?.EndTime !== "") {
                                                    if (convertToTimeObject(mainFridayModel?.EndTime, e.display) === 1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }

                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.FridayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='StartTime'
                                            name='StartTime'
                                            searchValue={mainFridayModel?.StartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainFridayModel?.EndTime !== "") {
                                                        return convertToTimeObject(mainFridayModel?.EndTime, e.display) === 1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedFriday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.FridayEndTime ? ' input  error' : ' input '}>
                                        <select
                                            className="form-control"
                                            id="EndTime"
                                            name="EndTime"
                                            value={mainFridayModel?.EndTime}
                                            onChange={handleFridayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainFridayModel?.StartTime !== "") {
                                                    if (convertToTimeObject(mainFridayModel?.StartTime, e.display) === -1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.FridayEndTime ? 'input error ' : 'input '}>
                                        <SuperSearchList
                                            type="client"
                                            id='EndTime'
                                            name='EndTime'
                                            searchValue={mainFridayModel?.EndTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainFridayModel?.StartTime !== "") {
                                                        return convertToTimeObject(mainFridayModel?.StartTime, e.display) === -1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedFriday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />



                                    </div>
                                </div>
                                <div className="col-md-3 pe-0">
                                    <div className={" input p-0 flex-row"}>
                                        {/* <select className="form-control"
                                            id='BreakStartTime'
                                            name='BreakStartTime'
                                            value={mainFridayModel?.BreakStartTime}
                                            onChange={handleFridayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainFridayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainFridayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display))) || index === 0) {

                                                    if (mainFridayModel?.BreakEndTime !== "") {
                                                        if (convertToTimeObject(mainFridayModel?.BreakEndTime, e.display) === 1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }

                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id="BreakStartTime"
                                            name="BreakStartTime"
                                            searchValue={mainFridayModel?.BreakStartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                    const start = parseTime(convert12HourTo24Hour(mainFridayModel.StartTime || "00:00 AM"));
                                                    const end = parseTime(convert12HourTo24Hour(mainFridayModel.EndTime || "11:59 PM"));

                                                    const isInRange = selectedTime > start && selectedTime < end;

                                                    if (!isInRange && index !== 0) return false;

                                                    if (mainFridayModel?.BreakEndTime) {
                                                        return convertToTimeObject(mainFridayModel?.BreakEndTime, e.display) === 1 || index === 0;
                                                    }

                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedFriday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center mx-1 form-check-input p-0'
                                                id="OverBookAllowed"
                                                name="OverBookAllowed"
                                                checked={mainFridayModel?.OverBookAllowed}
                                                value={mainFridayModel?.OverBookAllowed}
                                                onChange={(e) => handleFridayChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">

                                    <div className={" input ps-0"}>

                                        <select className="form-control"
                                            id='BreakEndTime'
                                            name='BreakEndTime'
                                            value={mainFridayModel?.BreakEndTime}
                                            onChange={handleFridayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainFridayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainFridayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display))) || index === 0) {

                                                    if (mainFridayModel?.BreakStartTime !== "") {
                                                        if (convertToTimeObject(mainFridayModel?.BreakStartTime, e.display) === -1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }
                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <SuperSearchList
                                        type="client"
                                        id="BreakEndTime"
                                        name="BreakEndTime"
                                        searchValue={mainFridayModel?.BreakEndTime || ''}
                                        data={
                                            TotalTime?.filter((e, index) => {
                                                const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                const start = parseTime(convert12HourTo24Hour(mainFridayModel.StartTime || "00:00 AM"));
                                                const end = parseTime(convert12HourTo24Hour(mainFridayModel.EndTime || "11:59 PM"));

                                                const isInRange = selectedTime > start && selectedTime < end;

                                                if (!isInRange && index !== 0) return false;

                                                if (mainFridayModel?.BreakStartTime) {
                                                    return convertToTimeObject(mainFridayModel?.BreakStartTime, e.display) === -1 || index === 0;
                                                }

                                                return true;
                                            })
                                        }
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedFriday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="row w-100">
                                <div className="heading day sat">
                                    <span>SAT</span>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.SaturdayStartTime ? ' input pe-0 error' : ' input pe-0'}>
                                        <select
                                            className="form-control"
                                            id="StartTime"
                                            name="StartTime"
                                            value={mainSaturdayModel?.StartTime}
                                            onChange={handleSaturdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainSaturdayModel?.EndTime !== "") {
                                                    if (convertToTimeObject(mainSaturdayModel?.EndTime, e.display) === 1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }

                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.SaturdayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='StartTime'
                                            name='StartTime'
                                            searchValue={mainSaturdayModel?.StartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainSaturdayModel?.EndTime !== "") {
                                                        return convertToTimeObject(mainSaturdayModel?.EndTime, e.display) === 1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedSaturday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.SaturdayEndTime ? ' input  error' : ' input '}>
                                        <select
                                            className="form-control"
                                            id="EndTime"
                                            name="EndTime"
                                            value={mainSaturdayModel?.EndTime}
                                            onChange={handleSaturdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainSaturdayModel?.StartTime !== "") {
                                                    if (convertToTimeObject(mainSaturdayModel?.StartTime, e.display) === -1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.SaturdayEndTime ? 'input error ' : 'input '}>
                                        <SuperSearchList
                                            type="client"
                                            id='EndTime'
                                            name='EndTime'
                                            searchValue={mainSaturdayModel?.EndTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainSaturdayModel?.StartTime !== "") {
                                                        return convertToTimeObject(mainSaturdayModel?.StartTime, e.display) === -1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedSaturday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />



                                    </div>
                                </div>
                                <div className="col-md-3 pe-0">
                                    <div className={"input p-0 flex-row"}>

                                        {/* <select className="form-control"
                                            id='BreakStartTime'
                                            name='BreakStartTime'
                                            value={mainSaturdayModel?.BreakStartTime}
                                            onChange={handleSaturdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainSaturdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainSaturdayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display))) || index === 0) {

                                                    if (mainSaturdayModel?.BreakEndTime !== "") {
                                                        if (convertToTimeObject(mainSaturdayModel?.BreakEndTime, e.display) === 1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }

                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id="BreakStartTime"
                                            name="BreakStartTime"
                                            searchValue={mainSaturdayModel?.BreakStartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                    const start = parseTime(convert12HourTo24Hour(mainSaturdayModel.StartTime || "00:00 AM"));
                                                    const end = parseTime(convert12HourTo24Hour(mainSaturdayModel.EndTime || "11:59 PM"));

                                                    const isInRange = selectedTime > start && selectedTime < end;

                                                    if (!isInRange && index !== 0) return false;

                                                    if (mainSaturdayModel?.BreakEndTime) {
                                                        return convertToTimeObject(mainSaturdayModel?.BreakEndTime, e.display) === 1 || index === 0;
                                                    }

                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedSaturday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center mx-1 form-check-input p-0'
                                                id="OverBookAllowed"
                                                name="OverBookAllowed"
                                                checked={mainSaturdayModel?.OverBookAllowed}
                                                value={mainSaturdayModel?.OverBookAllowed}
                                                onChange={(e) => handleSaturdayChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">

                                    <div className={" input ps-0"}>

                                        <select className="form-control"
                                            id='BreakEndTime'
                                            name='BreakEndTime'
                                            value={mainSaturdayModel?.BreakEndTime}
                                            onChange={handleSaturdayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainSaturdayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainSaturdayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display))) || index === 0) {

                                                    if (mainSaturdayModel?.BreakStartTime !== "") {
                                                        if (convertToTimeObject(mainSaturdayModel?.BreakStartTime, e.display) === -1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }
                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <SuperSearchList
                                        type="client"
                                        id="BreakEndTime"
                                        name="BreakEndTime"
                                        searchValue={mainSaturdayModel?.BreakEndTime || ''}
                                        data={
                                            TotalTime?.filter((e, index) => {
                                                const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                const start = parseTime(convert12HourTo24Hour(mainSaturdayModel.StartTime || "00:00 AM"));
                                                const end = parseTime(convert12HourTo24Hour(mainSaturdayModel.EndTime || "11:59 PM"));

                                                const isInRange = selectedTime > start && selectedTime < end;

                                                if (!isInRange && index !== 0) return false;

                                                if (mainSaturdayModel?.BreakStartTime) {
                                                    return convertToTimeObject(mainSaturdayModel?.BreakStartTime, e.display) === -1 || index === 0;
                                                }

                                                return true;
                                            })
                                        }
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedSaturday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="row w-100">
                                <div className="heading day sun">
                                    <span>SUN</span>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.SundayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <select
                                            className="form-control"
                                            id="StartTime"
                                            name="StartTime"
                                            value={mainSundayModel?.StartTime}
                                            onChange={handleSundayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainSundayModel?.EndTime !== "") {
                                                    if (convertToTimeObject(mainSundayModel?.EndTime, e.display) === 1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }

                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.SundayStartTime ? 'input pe-0 error' : 'input pe-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='StartTime'
                                            name='StartTime'
                                            searchValue={mainSundayModel?.StartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainSundayModel?.EndTime !== "") {
                                                        return convertToTimeObject(mainSundayModel?.EndTime, e.display) === 1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedSunday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={POSValidationModal.SundayEndTime ? 'input  error' : 'input '}>
                                        <select
                                            className="form-control"
                                            id="EndTime"
                                            name="EndTime"
                                            value={mainSundayModel?.EndTime}
                                            onChange={handleSundayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if (mainSundayModel?.StartTime !== "") {
                                                    if (convertToTimeObject(mainSundayModel?.StartTime, e.display) === -1 || index === 0)
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                }
                                                else {
                                                    return (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    );
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <div className={POSValidationModal.SaturdayEndTime ? 'input error ' : 'input '}>
                                        <SuperSearchList
                                            type="client"
                                            id='EndTime'
                                            name='EndTime'
                                            searchValue={mainSundayModel?.EndTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    if (mainSundayModel?.StartTime !== "") {
                                                        return convertToTimeObject(mainSundayModel?.StartTime, e.display) === -1 || index === 0;
                                                    }
                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedSunday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />



                                    </div>
                                </div>
                                <div className="col-md-3 pe-0">
                                    <div className={"input p-0 flex-row"}>

                                        {/* <select className="form-control"
                                            id='BreakStartTime'
                                            name='BreakStartTime'
                                            value={mainSundayModel?.BreakStartTime}
                                            onChange={handleSundayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainSundayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainSundayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display))) || index === 0) {

                                                    if (mainSundayModel?.BreakEndTime !== "") {
                                                        if (convertToTimeObject(mainSundayModel?.BreakEndTime, e.display) === 1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }

                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id="BreakStartTime"
                                            name="BreakStartTime"
                                            searchValue={mainSundayModel?.BreakStartTime || ''}
                                            data={
                                                TotalTime?.filter((e, index) => {
                                                    const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                    const start = parseTime(convert12HourTo24Hour(mainSundayModel.StartTime || "00:00 AM"));
                                                    const end = parseTime(convert12HourTo24Hour(mainSundayModel.EndTime || "11:59 PM"));

                                                    const isInRange = selectedTime > start && selectedTime < end;

                                                    if (!isInRange && index !== 0) return false;

                                                    if (mainSundayModel?.BreakEndTime) {
                                                        return convertToTimeObject(mainSundayModel?.BreakEndTime, e.display) === 1 || index === 0;
                                                    }

                                                    return true;
                                                })
                                            }
                                            onChange={handleVisitTypeChange}
                                            getSelectedData={handleSelectedSunday}
                                            is={is}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center mx-1 form-check-input p-0'
                                                id="OverBookAllowed"
                                                name="OverBookAllowed"
                                                checked={mainSundayModel?.OverBookAllowed}
                                                value={mainSundayModel?.OverBookAllowed}
                                                onChange={(e) => handleSundayChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-3 pe-0">
                                    <div className={"input ps-0"}>

                                        <select className="form-control"
                                            id='BreakEndTime'
                                            name='BreakEndTime'
                                            value={mainSundayModel?.BreakEndTime}
                                            onChange={handleSundayChange}
                                        >
                                            {TotalTime?.map((e, index) => {
                                                if ((parseTime(convert12HourTo24Hour(mainSundayModel.EndTime)) > parseTime(convert12HourTo24Hour(e.display)) && parseTime(convert12HourTo24Hour(mainSundayModel.StartTime)) < parseTime(convert12HourTo24Hour(e.display))) || index === 0) {
                                                    if (mainSundayModel?.BreakStartTime !== "") {
                                                        if (convertToTimeObject(mainSundayModel?.BreakStartTime, e.display) === -1 || index === 0)
                                                            return (
                                                                <option value={e.value} key={index}>
                                                                    {e.display}
                                                                </option>
                                                            );
                                                    }
                                                    else {
                                                        return (
                                                            <option value={e.value} key={index}>
                                                                {e.display}
                                                            </option>
                                                        );
                                                    }
                                                }


                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-3 input">
                                    <SuperSearchList
                                        type="client"
                                        id="BreakEndTime"
                                        name="BreakEndTime"
                                        searchValue={mainSundayModel?.BreakEndTime || ''}
                                        data={
                                            TotalTime?.filter((e, index) => {
                                                const selectedTime = parseTime(convert12HourTo24Hour(e.display));
                                                const start = parseTime(convert12HourTo24Hour(mainSundayModel.StartTime || "00:00 AM"));
                                                const end = parseTime(convert12HourTo24Hour(mainSundayModel.EndTime || "11:59 PM"));

                                                const isInRange = selectedTime > start && selectedTime < end;

                                                if (!isInRange && index !== 0) return false;

                                                if (mainSundayModel?.BreakStartTime) {
                                                    return convertToTimeObject(mainSundayModel?.BreakStartTime, e.display) === -1 || index === 0;
                                                }

                                                return true;
                                            })
                                        }
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedSunday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <ModalFooter handleSave={handleSaveVistType} isSaved={isClosed} IsEditAllowed={IsEditAllowed} />
            </Modal>
        </>
    )
}

export default LocationProvider